import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
  display: block;
  margin: auto auto;
`;

const SendPackageIcon: VFC<IIconProps> = ({ color, size }) => (
  <Wrapper>
    <svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 -2 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 14.8V9.2c0-.246-.062-.487-.179-.7a1.369 1.369 0 0 0-.488-.512l-4.666-2.8a1.285 1.285 0 0 0-1.334 0l-4.666 2.8c-.203.123-.371.3-.488.512a1.454 1.454 0 0 0-.179.7v5.6c0 .246.062.487.179.7.117.213.285.389.488.512l4.666 2.8a1.285 1.285 0 0 0 1.334 0l4.666-2.8c.203-.123.371-.3.488-.512.117-.213.179-.454.179-.7Z"
        stroke={color}
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="m10 9 6 3 6-3"
        stroke={color}
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M16 19v-7"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8h4M2 12h4M2 16h4"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  </Wrapper>
);

export default SendPackageIcon;
